import { Component, Inject, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { FormServices } from "src/app/services/form.services";
import { AgentServicev2 } from "../agent-builder-services/agent.service";
import { LanguageServices } from "src/app/services/LanguageServices";

@Component({
    selector: 'agent-builder-database',
    templateUrl: './agent-builder-database.component.html',
    styleUrls: ['./agent-builder-database.component.scss'],
    standalone: false
})

export class AgentBuilderDatabaseComponent {
    form:FormGroup;
    constructor(@Inject(NZ_MODAL_DATA) public nzData:any, 
            private formBuilder: FormBuilder) {

        this.form = this.formBuilder.group({
            dbName: [null, Validators.required],
            description: [null, Validators.required],
            codecontract: [nzData.codecontract ? nzData.codecontract : null, Validators.required]
        });
    }

    
}